module.exports = __webpack_public_path__ + "static/fb-18efbfbe20cdb8050f3193910d85c153.svg";